import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from '../models/loader-state';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly loaderSubject: Subject<LoaderState> = new Subject<LoaderState>();

  loaderState = this.loaderSubject.asObservable();

  show(): void {
    this.loaderSubject.next({ show: true } as LoaderState);
  }

  hide(): void {
    this.loaderSubject.next({ show: false } as LoaderState);
  }
}
